/**
 * Hero callouts — each marker folds its own card away.
 *
 * The cards ship open, so the hero renders as drawn with no JS at all; this only
 * adds the ability to clear one out of the way of the render behind it. The
 * markers are `display: none` below lg (see css/base/plans.css), where the same
 * three cards are a plain list under the drawing instead — so nothing here has
 * anything to do on a phone.
 */
export function initPlanHotspots() {
    document.querySelectorAll('[data-hero-hotspot]').forEach((marker) => {
        const card = document.getElementById(marker.getAttribute('aria-controls'))
        if (!card) return

        marker.addEventListener('click', () => {
            const open = marker.getAttribute('aria-expanded') !== 'true'
            marker.setAttribute('aria-expanded', String(open))
            card.setAttribute('aria-hidden', String(!open))
        })
    })
}
